// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@insite/mobius/LazyImage";
import { bannerStyles } from "@rpsc/Overrides/Widgets/Category/CategoryDetailBanner";
import { layoutContainer, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

bannerStyles.container = {
    css: css`
        ${xScreen("lte", "md")} {
            max-height: 100%;
        }
        ${LazyImageStyle} {
            ${xScreen("lte", "md")} {
                height: 375px;
                margin: auto;
                order: 0;
                img {
                    object-fit: ${({ isFullWidth }: any) => (isFullWidth ? `cover` : `contain`)};
                }
            }
            ${xScreen("lte", "xs")} {
                height: 176px;
                picture {
                    height: 100%;
                }
            }
        }
        ${({ isFullWidth, contentBgColor }: any) =>
            isFullWidth
                ? css`
                      & > body {
                          background: ${contentBgColor};
                      }
                      .banner-content {
                          ${layoutContainer}
                          ${xScreen("lte", "md")} {
                              margin: 0 !important;
                              padding: 0 !important;
                          }
                      }
                  `
                : css`
                      ${layoutContainer}
                      ${LazyImageStyle} {
                          img {
                              width: auto;
                              height: auto;
                              margin-left: auto;
                              ${xScreen("lte", "md")} {
                                  margin: auto;
                              }
                          }
                      }
                      .banner-container {
                          > div:last-child {
                              width: 100%;
                          }
                      }
                  `}
    `,
};
